import { Directive, Output, EventEmitter, HostListener } from '@angular/core';

@Directive({
	selector: '[easterEgg]',
	host: {
		'(click)': 'onClick($event)',
	}
})

export class EasterEggDirective {

	@Output()
	public easterEgg = new EventEmitter<MouseEvent>();

	constructor() { }

	@HostListener('click', ['$event', '$event.target'])
	public onClick(event: MouseEvent, targetElement: HTMLElement): void {

		if (!targetElement) {
			return;
		}

		if (event.altKey && event.shiftKey) {
			event.stopPropagation();
			this.easterEgg.emit(event);
		}
	}
}
